import React, { useEffect, useState, useRef } from 'react';
import DropDownSearch from '../../../../../components/DropDownSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Form, Row, Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Modal from '../../../../../components/Modal';
import {
  faCircleQuestion,
  faUserTimes,
  faCopy
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import AssignMenuPreviewModal from './AssignMenuPreviewModal';
import {
  useGetClassesMutation,
  useGetStudentsDetailsByClassesMutation
} from '../../../../../features/authentication/authApiSlice';
import {
  useGetClassFilterMutation,
  useUpdateClassFilterMutation
} from '../../../../../features/authentication/persistApiSlice';
import { useAssignmentContext } from '../../../context';
import GoogleClassroomShareModal from '../../../../../components/GoogleClassroomShareModal/index';
import AssignmentSettings from '../../../../../components/AssignmentSettings';
import {
  useAssignStudentsMutation,
  useCheckIsCRQuestionExistMutation,
  useCreateAssignmentLinkMutation
} from '../../../../../features/authentication/assignApiSlice';
import CustomToast from '../../../../../components/Toast';
import ToastTable from '../../../../../components/ToastTable';
import { useGetUserIdMutation } from '../../../../../features/authentication/dashboardHeaderApiSlice';
import assignedVia_1 from '../../../../../assets/images/assignedVia_1.png';
import assignedVia_2 from '../../../../../assets/images/assignedVia_2.png';
import assignedVia_3 from '../../../../../assets/images/assignedVia_3.png';
import assignedVia_4 from '../../../../../assets/images/assignedVia_4.png';
import { useCheckIsSelfAssignedMutation } from '../../../../../features/authentication/assignApiSlice';
import moment from 'moment';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import InfiniteScroll from 'react-infinite-scroll-component';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { useCheckIsStudentPdfExistMutation } from '../../../../../features/authentication/pdfGeneratorApiSlice';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import ActivityTypes from '../../../../../enums/activityTypes';

const AssignMenuModal = ({ modalData, setModalData, enableCreateLink, fromMoreActions = false }) => {
  const assignedViaOptions = [
    { assignedViaId: 1, className: 'castle', name: 'Castle', image: assignedVia_1 },
    { assignedViaId: 2, className: 'google', name: 'Google Classroom', image: assignedVia_2 },
    { assignedViaId: 3, className: 'schoology', name: 'Schoology', image: assignedVia_3 },
    { assignedViaId: 4, className: 'canvas', name: 'Canvas', image: assignedVia_4 }
  ];

  const [getAllClasses] = useGetClassesMutation();
  const [getClassFilter] = useGetClassFilterMutation();
  const [updateClassFilter] = useUpdateClassFilterMutation();
  const [getAllStudents] = useGetStudentsDetailsByClassesMutation();
  const [allAssignedData,{isLoading: isAssigning}] = useAssignStudentsMutation();
  const [getUserId, getUserIdResults] = useGetUserIdMutation();
  const [checkIsStudentPdfExist] = useCheckIsStudentPdfExistMutation();
  const [selectedClassIds, setSelectedClassIds] = useState([]);
  const [notAssignedData, setNotAssignedData] = useState([]);
  const [previewAssignmentModal, setPreviewAssignmentModal] = useState(false);
  const [classDetails, setClassDetails] = useState([]);
  const [totalNotAssigned, setTotalNotAssigned] = useState(0);
  const [assignToSelf, setAssignToSelf] = useState(false);
  const [count, setCount] = useState(0);
  const [toastTable, setToastTable] = useState(false);
  const [assignedResponse, setAssignedResponse] = useState([]);
  const [userId, setUserId] = useState();
  const assignmentContext = useAssignmentContext();
  const { setAssignedDataStatus, setAssignmentOptions, setAssignedData } = useAssignmentContext();
  const [createAssignmentLinkCall,{isLoading: isCreatingAssignmentLink}] = useCreateAssignmentLinkMutation();
  const [assignmentMethodId, setAssignmentMethodId] = useState(1);
  const [showShareToGoogleClassroomModal, setShowShareToGoogleClassroomModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const createdAssignmentLink = useRef('');
  const [checkAllSelfAssigned] = useCheckIsSelfAssignedMutation();
  const [isLoading, setIsLoading] = useState(false);
  const [modalTitle, setModalTitle] = useState(enableCreateLink ? 'Create Assignment(s) Link' : 'Assign Assignment(s) to Students');
  const [isAssignToSelf, setIsAssignToSelf] = useState(false);
  const [skipValue, setSkipValue] = useState(0);
  const [isLoadingStudents, setIsLoadingStudents] = useState(false);
  const [showStudentPrinting, setShowStudentPrinting] = useState(false);
  const [showCRConfirmation, setShowCRConfirmation] = useState(false);
  const [showConfirmationOnAssign, setShowConfirmationOnAssign] = useState(false);
  const [apiParams, setApiParams] = useState({});
  const [apiIdentifier, setApiIdentifier] = useState('');
  const [checkCRQuestionExist] = useCheckIsCRQuestionExistMutation();
  const [checkedAllStudents, setCheckedAllStudents] = useState(false);

  const takeSize = 100;

  const getAllClassesAsync = async () => {
    try {
      const persistIds = await getClassFilter().unwrap();
      let classes = localStorage.getItem('classes');
      if(classes)
        classes = JSON.parse(classes);
      else{
        classes = await getAllClasses().unwrap();
        localStorage.setItem('classes', JSON.stringify(classes));
      }      
      const formattedClasses = classes.map((item) => ({
        id: item.classID,
        name: item.className,
        description: item.coTeacherClass ? item.teacherName : '',
        isChecked: persistIds?.includes(item.classID) ?? false
      }));
      setClassDetails(formattedClasses);
      setSelectedClassIds(persistIds ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (assignmentContext.assignedData.length === 1)
      assignmentContext.setAssignmentId(assignmentContext.assignedData[0].assignmentId);
    getUserIdAsync();

    if(assignmentContext.isAllSelected){
      setIsAssignToSelf(true);
      setShowStudentPrinting(true);
    }
    else{
      checkIsSelfAssigned();
      checkIsStudentPdfExistAsync();
    }

  }, []);

  const checkIsStudentPdfExistAsync = async ()=>{
    const assignmentIds = assignmentContext.assignedData.map(item => item.assignmentId);
    const response = await checkIsStudentPdfExist(assignmentIds).unwrap();
    setShowStudentPrinting(response.isStudentPdfExist);
  };

  useEffect(() => {
    if (selectedClassIds.length > 0) {
      setSkipValue(0);
      loadInitialData(0, takeSize);
    } else {
      setNotAssignedData([]);
      setTotalNotAssigned(0);
    }
  }, [selectedClassIds]);

  useEffect(() => {
    getAllClassesAsync();
  }, []);

  useEffect(() => {
    if (!modalData) return;
    var assignmentTitle = 'Assign Assignment(s) to Students';
    var assignedViaDetails = assignedViaOptions.find(
      (c) => c.assignedViaId == assignmentContext.assignedData[0].assignedVia
    );

    if (assignmentContext.assignedData.length === 1) {
      const assignmentName = assignmentContext.assignedData[0].assignmentName;
      assignmentTitle = enableCreateLink ? `Create Link : ${assignmentName}` : `Assign ${assignmentName} to Students`;
    } else {
      assignmentTitle = enableCreateLink ? 'Create Assignments Link' : 'Assign Assignments to Students';
    }

    var modalTitle = (
      <>
        {assignmentTitle}
        {assignedViaDetails && (
          <span className={`manage-assign-card manage-badge ${assignedViaDetails.className} ms-2`}>
            <span>
              <img
                src={assignedViaDetails.image}
                className="img-fluid"
                alt={`Assigned via ${assignedViaDetails.name}`}
              />
            </span>
            {assignedViaDetails.name}
          </span>
        )}
      </>
    );
    setModalTitle(modalTitle);
    if(!assignmentContext.isAllSelected)
      setAssignmentMethodId(assignmentContext.assignedData[0].assignedVia);
  }, [modalData]);

  const loadInitialData = async (skip, takeSize) => {
    setIsLoading(true);
    const { total, data } = await getAllStudentsAsync(skip, takeSize);
    setNotAssignedData(data);
    setTotalNotAssigned(total);
    setIsLoading(false);
  };

  const handleClassSelectionChange = (e) => {
    setCheckedAllStudents(false);
    const { key } = e;
    let tempValue = [];

    if (key === '000') {
      const selectAll = classDetails.some((item) => item?.isChecked !== true);
      tempValue = classDetails.map((item) => ({ ...item, isChecked: selectAll }));
    } else {
      const selected = classDetails.find((v) => v.id == key);
      tempValue = classDetails.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }

    setClassDetails(tempValue);
    const ids = tempValue.filter((item) => item?.isChecked === true).map((item) => item.id);
    setSelectedClassIds(ids);
    setClassIdsFilter(ids);
  };

  const setClassIdsFilter = async (ids) => {
    try {
      await updateClassFilter(ids).unwrap();
    } catch (error) {
      console.log(error);
    }
  };

  const getAllStudentsAsync = async (skip, take) => {
    try {
      const options = { classIds: selectedClassIds };
      if (skip !== undefined && skip !== '') options.skip = skip;
      if (take !== undefined && take !== '') options.take = take;

      if(assignmentContext.isAllSelected)
        options.aIds = [-1];
      else if (assignmentContext.assignedData.length > 0)
        options.aIds = assignmentContext.assignedData.map((item) => item.assignmentId);

      if (assignmentContext.assignedData.length === 1)
        assignmentContext.setAssignmentId(assignmentContext.assignedData[0].assignmentId);

      const response = await getAllStudents(options).unwrap();
      return { total: response?.total ?? 0, data: response?.data ?? [] };
    } catch (error) {
      console.log(error);
      return { total: 0, data: [] };
    }
  };

  const getStudentKey = (student) => `${student.classId}-${student.studentId}`;

  const handleChange = (e) => {
    const { name, checked } = e.target;
    let tempNotAssignedData = [];
    if (name === 'assignCheck') {
      tempNotAssignedData = notAssignedData.map((item) => {
        return { ...item, isChecked: checked };
      });
      setCheckedAllStudents(checked);
    } else {
      tempNotAssignedData = notAssignedData.map((item) =>
        getStudentKey(item) === name && !item.deleted ? { ...item, isChecked: checked } : item
      );
      setCheckedAllStudents(tempNotAssignedData.every((item) => item.isChecked));
    }
    setNotAssignedData(tempNotAssignedData);
  };

  const previewAssignmentHandler = () => {
    setPreviewAssignmentModal(!previewAssignmentModal);
  };

  const handleAssignSelf = (event) => {
    const checked = event.target.checked;
    setAssignToSelf(checked);
  };

  const getUserIdAsync = async () => {
    try {
      const response = await getUserId().unwrap();
      setUserId(response.userId);
    } catch (error) {
      console.log(error);
    }
  };

  const resetAssignModal = () => {
    setAssignToSelf(false);
    setCount(count + 1);
    setNotAssignedData(
      notAssignedData.map((item) => {
        return { ...item, isChecked: false };
      })
    );
    setSkipValue(0);
    setCheckedAllStudents(false);
  };

  const validateAssignmentData = async (apiIdentifier) => {
    const retakeTimeSpan = parseInt(assignmentContext.retakeTimedHour * 60) + parseInt(assignmentContext.retakeTimedMinute);
    const timedTimeSpan =
      parseInt(assignmentContext.timedHour * 60) + parseInt(assignmentContext.timedMinute);

    let students = [];
    if (assignToSelf) {
      students.push({ studentId: userId, classId: selectedClassIds[0] ?? -1 });
    }
    notAssignedData
      .filter((item) => item.isChecked === true)
      .map((data) => students.push({ studentId: data.studentId, classId: data.classId }));

    if (
      assignToSelf === false &&
      students.length <= 0 &&
      assignmentContext.assignedData[0].assignedVia === 1
    ) {
      CustomToast('Please check at least one student in the "Not Assigned" list', 'info');
      return;
    }

    if (assignmentContext.availabilityOption !== 'offline') {
      if (!assignmentContext.assignmentMode) {
        CustomToast('Please select the assignment mode', 'warning');
        return;
      }
    }
    if (assignmentContext.isTimed && timedTimeSpan <= 0) {
      CustomToast('The time length must be greater than 0 minutes.', 'info');
      return;
    }

    if (assignmentContext.availabilityOption == 'FromTo') {
      const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
      if(moment(assignmentContext.startDate).isBefore(currentDate, 'day')){
        CustomToast('From Date must not be before the current day', 'error');
        return;
      }
      if(moment(assignmentContext.endDate).isBefore(currentDate)){
        CustomToast('To Date must not be before the current date/time', 'error');
        return;
      }
      if(moment(assignmentContext.endDate).isBefore(moment(assignmentContext.startDate)) || moment(assignmentContext.endDate).isSame(moment(assignmentContext.startDate))){
        CustomToast('To Date must be after the From Date', 'error');
        return;
      }
    }

    if (assignmentContext.retakesEnabled) {
      if (assignmentContext.retakeLimitValue <= 0) {
        CustomToast('You must select a retake limit', 'info');
        return;
      }
      if (assignmentContext.retakeAvailabilty == 'fromto') {
        const currentDate = moment().format('YYYY/MM/DD h:mm A'); // Get the current date/time
        if(moment(assignmentContext.retakeStartDate).isBefore(currentDate, 'day')){
          CustomToast('Retake From Date must not be before the current day', 'error');
          return;
        }
        if(moment(assignmentContext.retakeEndDate).isBefore(currentDate)){
          CustomToast('Retake To Date must not be before the current date/time', 'error');
          return;
        }
        if(moment(assignmentContext.retakeEndDate).isBefore(moment(assignmentContext.retakeStartDate)) || moment(assignmentContext.retakeEndDate).isSame(moment(assignmentContext.retakeStartDate))){
          CustomToast('Retake To Date must be after the Retake From Date', 'error');
          return;
        }
      }
      if (assignmentContext.isRetakeTimed && retakeTimeSpan <= 0) {
        CustomToast('The retake time length must be greater than 0 minutes.', 'info');
        return;
      }
      if (assignmentContext.retakeQuestion === null || assignmentContext.retakeQuestion == -1) {
        CustomToast(
          'You must select an option for Auto Graded Questions to include on Retakes',
          'info'
        );
        return;
      }
      if (assignmentContext.includeCR === null || assignmentContext.includeCR == -1) {
        CustomToast('You must select an option for CR Questions to include on Retakes', 'info');
        return;
      }
    }
    if(assignmentMethodId == 1 && !showCRConfirmation && assignmentContext.retakesEnabled){
      const params = new URLSearchParams();
      assignmentContext.assignedData.forEach(item => params.append('ids', item.assignmentId));
      const response = await checkCRQuestionExist(params.toString()).unwrap();
      if(response.isCRQuestionExist)
      {
        setShowCRConfirmation(true);
        return;
      }
    }
   
    let options = {
      classIds: selectedClassIds,
      studentIds: checkedAllStudents ? [-1] : students.map(student => student.studentId),
      students: assignmentMethodId === 1 && students.length == notAssignedData.length
        ? selectedClassIds.map((classId) => ({ studentId: -1, classId }))
        : students,
      selfAssign: assignToSelf,
      availability: assignmentContext.availabilityOption,
      assignmentMode: assignmentContext.assignmentMode,
      allowAnswerChange: assignmentContext.allowAnswerChange,
      showGrade: assignmentContext.showGrade,
      startDate: assignmentContext.startDate != '' ? moment(assignmentContext.startDate).format('YYYY/MM/DD h:mm A') : '',
      endDate: assignmentContext.endDate != '' ? moment(assignmentContext.endDate).format('YYYY/MM/DD h:mm A') : '',
      studentFileUpload: assignmentContext.studentFileUpload,
      timed: assignmentContext.isTimed,
      timeSpan: timedTimeSpan,
      practice: true,
      assignRetake: assignmentContext.retakesEnabled,
      masteryLevel: assignmentContext.masteryValue,
      retakeMode: assignmentContext.retakeMode,
      scoreRetries: assignmentContext.autoScoreRetries,
      retakeLimit: assignmentContext.retakeLimitValue,
      retakeAvailability: assignmentContext.retakeAvailabilty,
      retakeStartDate: assignmentContext.retakeStartDate,
      retakeEndDate: assignmentContext.retakeEndDate,
      retakeTimed: assignmentContext.isRetakeTimed,
      retakeTimeSpan: retakeTimeSpan,
      retakeQuestion: assignmentContext.retakeQuestion == -1 ? 0 : assignmentContext.retakeQuestion,
      includeCR: assignmentContext.includeCR == 1,
      randomized: assignmentContext.randomized,
      textToSpeech: assignmentContext.textToSpeech,
      autoLockQuestions: assignmentContext.autoLockQuestions,
      allowLangChange: assignmentContext.allowLangChange,
      useCalc: assignmentContext.calculatorEnabled ? 1 : 0,
      useProtractor: assignmentContext.useProtractor ? 1 : 0,
      useRuler: assignmentContext.useRuler ? 1 : 0,
      timeOnTask: assignmentContext.timeOnTaskEnabled,
      period: assignmentContext.timeOnTaskSeconds,
      lockBrowser: assignmentContext.lockBrowser,
      photoMathBlock: assignmentContext.photoMathBlock,
      autoStartCRUponGrading: assignmentContext.autoStartCRUponGrading,
      cranswerToolId: assignmentContext.crAnswerToolType,
      calculatorType: assignmentContext.calculatorType,
      assignedVia: assignmentMethodId
    };

    if(assignmentContext.isAllSelected){
      options.assignmentIds = [-1];
      const filters = {
        assignmentStatus : assignmentContext.filters.assignmentStatus,
        assignedVia: assignmentContext.filters.assignedVia,
        courseId: assignmentContext.filters.courseId,
        folderId: assignmentContext.filters.folderId,
        searchText: assignmentContext.filters.selectedKeyWord
      };
      options.filters = filters;
      options.activityType = ActivityTypes.Assignment;
    }
    else
      options.assignmentIds =assignmentContext.assignedData.map((assignment) => {
        return assignment.assignmentId;
      });
    setShowConfirmationOnAssign(true);
    setApiParams(options);
    setApiIdentifier(apiIdentifier); 
  };

  const createLinkAndShareToGoogle = async (assignmentOptions) => {
    assignmentOptions.students = [{ studentId: getUserIdResults.data.userId, classId: -1 }];
    setAssignmentOptions(assignmentOptions);
    setShowShareToGoogleClassroomModal(true);
  };

  const createAssignmentLink = async (assignmentOptions) => {
    try {
      assignmentOptions.students = [{ studentId: getUserIdResults.data.userId, classId: -1 }];
      setIsLoading(true);

      createdAssignmentLink.current = await createAssignmentLinkCall(assignmentOptions).unwrap();
      if (createdAssignmentLink.current.length > 1) {
        setModalData(false);
        CustomToast(
          'Assignment links have been created, you can find them under "View Assignment Links"',
          'success'
        );
      } else if (createdAssignmentLink.current.length === 1) {
        setShowLinkModal(true);
      } else {
        CustomToast('Error! Couldn\'t create assignment link', 'error');
      }
      setIsLoading(false);
    } catch (ex) {
      CustomToast('Error! Couldn\'t create assignment link', 'error');
      setIsLoading(false);
      console.log(ex);
    }
  };

  function copyLinkToClipboard(fullUrl) {
    navigator.clipboard.writeText(fullUrl);
    CustomToast('Link copied', 'info');
  }

  const assignDataHandler = async (assignmentOptions) => {
    try {
      let studentsAssignedArray = [];
      setIsLoading(true);
      assignmentOptions.studentPrinting = assignmentContext.allowStudentToPrintPdf;
      const allAssignedDataResponse = await allAssignedData(assignmentOptions).unwrap();
      allAssignedDataResponse.map((item) => {
        if (item.studentsAssigned > 0) {
          studentsAssignedArray.push(item.studentsAssigned);
        }
      });
      if (allAssignedDataResponse.length > 0) {
        setToastTable(true);
        setAssignedResponse(allAssignedDataResponse);
      } else {
        setToastTable(false);
        CustomToast('Error! Couldn\'t Assign', 'error');
      }
      setIsLoading(false);
      setShowCRConfirmation(false);

      resetAssignModal();
    } catch (ex) {
      CustomToast(ex.data?.error ?? ex.error ?? 'Unexpected server error', 'error');
      console.log(ex);
      setIsLoading(false);
    }
  };

  const ontoastCloseHandler = () => {
    setToastTable(false);
    setModalData(false);
    setAssignedData([]);
    setAssignedDataStatus(new Date().getSeconds());
  };

  const checkIsSelfAssigned = async () => {
    try {
      const options = {
        assignmentIds: assignmentContext.assignedData.map((item) => item.assignmentId)
      };
      const checkSelfAssignResponse = await checkAllSelfAssigned(options).unwrap();
      if (checkSelfAssignResponse) setIsAssignToSelf(true);
    } catch (ex) {
      console.log(ex);
    }
  };

  const nextCallback = async (newOffset) => {
    setIsLoadingStudents(true);
    setSkipValue(newOffset);
    const { data } = await getAllStudentsAsync(newOffset, takeSize);
    let newItems = [...notAssignedData, ...data];
    let distinctData = distinctObjects(newItems);
    setNotAssignedData(distinctData);
    setIsLoadingStudents(false);
  };

  const distinctObjects = (data) => {
    return Array.from(
      data.reduce((map, obj) => map.set(getStudentKey(obj), obj), new Map()).values()
    );
  };

  const handleModalClose = () => {
    if(fromMoreActions) {  
      setAssignedData([]);
      setAssignedDataStatus(new Date().getSeconds());
    }

    setModalData(false);
    resetAssignModal();
  };

  const handleApiCall = () => {
    setShowConfirmationOnAssign(false);
    switch (apiIdentifier) {
    case 'assign':
      assignDataHandler(apiParams);
      break;
  
    case 'createLink':
      createAssignmentLink(apiParams);
      break;
  
    case 'createLinkAndShare':
      createLinkAndShareToGoogle(apiParams);
      break;
    }
  };

  const getConfirmationText = ()=>{
    if(assignmentContext.isAllSelected)
      return 'Are you sure that you want to assign <strong>all assignments</strong> to selected students?';
    else if(assignmentContext.assignedData.length > 1)
      return `Are you sure that you want to assign checked <strong>${assignmentContext.assignedData.length} assignments</strong> to selected students?`;
    return 'Are you sure that you want to assign this assignment to selected students?';
  };

  return (
    <>
      <Modal
        contentWidth={assignmentMethodId === 1 ? '100%' : '75%'}
        isOpen={modalData}
        titleName={modalTitle}
        onClose={() => handleModalClose()}
      >
        <Row>
          {assignmentMethodId === 1 && (
            <Col className="col-lg-6 p-20 assign-left">
              <div className="d-flex align-items-center gap-4">
                <Form.Group style={{ width: '60%' }}>
                  <Form.Label htmlFor="assignMenuClassesFilter">Class</Form.Label>
                  <DropDownSearch
                    value={classDetails}
                    dropdownId="assignMenuClassesFilter"
                    placeholder="Filter Classes"
                    handleChange={(e) => handleClassSelectionChange(e)}
                    selectedId={selectedClassIds}
                    description={true}
                    selectAllText="All Classes"
                    coteacherText={true}
                  />
                </Form.Group>
                {isAssignToSelf && (
                  <div className="form-check d-flex align-items-center mt-4 assign-settings-header">
                    <span>
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="assignToSelf"
                        id="assignToSelf"
                        checked={assignToSelf}
                        onClick={(e) => handleAssignSelf(e)}
                      />
                      <label className="form-check-label ms-2" htmlFor="assignToSelf">
                        Assign to self
                      </label>
                    </span>
                  </div>
                )}
              </div>
              <div className="my-4 gap-2">
                <span className="primary-title">Not Assigned</span> ({totalNotAssigned}){' '}
                <OverlayTrigger
                  key="tooltip-notAssigned"
                  placement="top"
                  overlay={
                    <Tooltip id="not-assigned-info" className="not-assigned-tooltip">
                      <p>
                        The following students are in the class, but you have NOT assigned these
                        assignments to them. To add students to the assignments, check the box next
                        to the names and click ASSIGN.
                      </p>
                    </Tooltip>
                  }>
                  <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
                </OverlayTrigger>
              </div>
              {isLoading ? (
                <TableSkeleton
                  rowCount={4}
                  colCount={3}
                  tableClass={'pt-4'}
                  skeletonClass={'pt-2'} />
              ) : (
                <InfiniteScroll
                  dataLength={notAssignedData.length}
                  next={() => nextCallback(skipValue + takeSize)}
                  hasMore={skipValue + takeSize < totalNotAssigned}
                  scrollableTarget='scrollableTable'>
                  <div id='scrollableTable' className="assignments-scroll-bar custom-table table-responsive not-assigned-table transparent-scroll" style={{ height: '520px', overflowY: 'auto' }}>
                    <table className="table currentlist-table">
                      <thead>
                        <tr>
                          <th className='height-unset'>
                            <div className="form-check">
                              {notAssignedData.length > 0 &&
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="assignCheck"
                                name="assignCheck"
                                checked={checkedAllStudents}
                                onChange={handleChange}
                              />
                              }
                            </div>
                          </th>
                          <th className='height-unset'>Last Name</th>
                          <th className='height-unset'>First Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading === false && (
                          <>
                            {notAssignedData.length > 0 ? (
                              <>
                                {notAssignedData.map((item, index) => (
                                  <tr key={`${getStudentKey(item)}-${index}`}>
                                    <td className='height-unset p-1'>
                                      {!item.deleted && (
                                        <div className="form-check mx-2">
                                          <input
                                            type="checkbox"
                                            name={getStudentKey(item)}
                                            checked={!!item?.isChecked}
                                            onChange={handleChange}
                                            className="form-check-input"
                                            id={`flexCheckDefault-${getStudentKey(item)}`}
                                          />
                                        </div>
                                      )}
                                      {item.deleted && (
                                        <OverlayTrigger
                                          placement="right"
                                          overlay={
                                            <Tooltip className="tooltip-white">
                                              <h4>Deactivated</h4>
                                              <p className="mb-0">
                                                Students cannot use deactivated accounts, but teacher
                                                and administrator reports do include data for these
                                                accounts{' '}
                                              </p>
                                            </Tooltip>
                                          }>
                                          <div className="deactivated">
                                            <FontAwesomeIcon icon={faUserTimes} />
                                          </div>
                                        </OverlayTrigger>
                                      )}
                                    </td>
                                    <td className={`${item.deleted ? 'disable-data' : ''} height-unset p-1`}>
                                      {item.lName}
                                    </td>
                                    <td className={`${item.deleted ? 'disable-data' : ''} height-unset p-1`}>
                                      {item.fName}
                                    </td>
                                  </tr>
                                ))}
                              </>
                            ) : (
                              <tr>
                                <td colSpan={3} className="fs-6 text-center">
                                  There is no more unassigned student in this class
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                      </tbody>
                    </table>
                    {isLoadingStudents &&
                      <div className='mt-3 text-center fs-4'>
                        <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'></span>
                      </div>
                    }
                  </div>
                </InfiniteScroll>
              )}
            </Col>
          )}
          <AssignmentSettings
            allowRetakesOption={assignmentMethodId === 1 ? true : false}
            headingDescription={true}
            availabilityRequired={true}
            modesRequired={true}
            showBetaButton={true}
            noColumn={assignmentMethodId === 1 ? false : true}
            randomizedQuestion={true}
            disabledTextSpeach={true}
            allowOfflineMode={true}
            isSelfAssign={false}
            showStudentPrinting={showStudentPrinting}
          />
        </Row>
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            onClick={() => handleModalClose()}>
            Cancel
          </button>
          {assignmentContext.assignedData?.length <= 1 && (
            <button className="btn btn-castleWhite preview-btn" onClick={previewAssignmentHandler}>
              Preview Assignment
            </button>
          )}

          {/* Assigned Via Castle */}
          {assignmentMethodId === 1 && (
            <button
              className="btn btn-castleRed print-btn"
              onClick={() => validateAssignmentData('assign')}
              disabled={isLoading}>
              Assign
            </button>
          )}
          {/* Assigned Via 3rd Party */}
          {assignmentMethodId !== 1 && (
            <button
              className="btn btn-castleRed flex-shrink-0"
              onClick={() => validateAssignmentData('createLink')}>
              {`Create Assignment Link${assignmentContext.assignedData.length === 1 ? '' : 's'}`}
            </button>
          )}
          {/* Assigned Via Google Classroom */}
          {assignmentMethodId === 2 && assignmentContext.assignedData.length === 1 && (
            <button
              className="createAndShareToGoogleBtn"
              onClick={() => validateAssignmentData('createLinkAndShare')}>
              Create link & share to Google Classroom
            </button>
          )}
        </div>
        {/* preview modal */}
        <AssignMenuPreviewModal
          modalData={previewAssignmentModal}
          setModalData={setPreviewAssignmentModal}
        />
        {/* preview modal */}
        {toastTable && <ToastTable data={assignedResponse} onClose={ontoastCloseHandler}  title={'Assignment'}/>}
      </Modal>

      {/* Link created modal */}
      <Modal
        contentWidth="40%"
        isOpen={showLinkModal}
        titleName={'Link Created'}
        onClose={() => {
          setShowLinkModal(false);
        }}>
        <div className="d-flex flex-column align-items-center">
          <div>
            An assignment link has been created! Click the icon below to copy it to your clipboard
            now.
          </div>

          <OverlayTrigger
            key="copyToClipboard"
            placement="top"
            overlay={<Tooltip className="custom-tooltip">Copy to Clipboard</Tooltip>}>
            <button
              className="copyLinkBtn my-3"
              onClick={() => copyLinkToClipboard(createdAssignmentLink.current[0])}>
              <FontAwesomeIcon icon={faCopy} />
            </button>
          </OverlayTrigger>

          <div>You can also find this link under &quot;View Assignment Links&quot;.</div>
        </div>
      </Modal>
      {showShareToGoogleClassroomModal &&
      <GoogleClassroomShareModal
        showShareToGoogleClassroomModal={showShareToGoogleClassroomModal}
        setShowShareToGoogleClassroomModal={setShowShareToGoogleClassroomModal}
        assignmentName={assignmentContext.assignedData[0]?.assignmentName}
        setShowParentModal={setModalData}
      />
      }
      {showCRConfirmation &&
      <ConfirmationModal
        isOpen={showCRConfirmation}
        onClose={() => setShowCRConfirmation(false)}
        onSave={() => validateAssignmentData('assign')}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content='Assignment contains CR Questions which will have to be scored prior to Automated Retakes being assigned to students who do not meet the Mastery Level. Do you still want to assign these assignments with Retakes?'
        cancelButton={'NO'}
        confirmButton={'YES'}
        titleName={'Confirm'}
        hideHeader={false}
        confirmationInProgress={isAssigning || isCreatingAssignmentLink}
      />
      }
      {showConfirmationOnAssign &&
      <ConfirmationModal
        isOpen={showConfirmationOnAssign}
        onClose={() => setShowConfirmationOnAssign(false)}
        onSave={() => handleApiCall()}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={getConfirmationText()}
        cancelButton={'NO'}
        confirmButton={'YES'}
        titleName={'Confirm'}
        hideheader={false}
      />
      }
    </>
  );
};

AssignMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  enableCreateLink: PropTypes.bool,
  fromMoreActions: PropTypes.bool
};

export default AssignMenuModal;
